import { useContext } from "react";
import Button from "../components/Button";
import Choices from "../components/Choices";
import { ReactComponent as IllusStep } from "../img/illustrations/infos.svg";
import { useSwiper } from "swiper/react";
import SimulationContext from "../contexts/Simulation";

const InfosStep = ({ step }) => {
  const [simParams, setSimParams] = useContext(SimulationContext);
  const swiper = useSwiper();

  const selectChoice = (c) => {
    setSimParams({
      ...simParams, 
      infos: {
        daily_presence: c.key === 'oui'
      }, 
      allowSlideNext: true, 
      validSteps: (simParams.validSteps & ~(1 << step)) | (1 << step)
    });
  }

  return (
    <div className="content infos">
      <IllusStep className="main-illus"/>
      <h3>Y a-t-il du monde à la maison en journée ?</h3>
      <div className="sub">Histoire de savoir si vos panneaux doivent bosser pour vous en temps réel… ou stocker pour plus tard !</div>
      <Choices choices={[
          {
            key: 'oui',
            label: 'Oui'
          },
          {
            key: 'non',
            label: 'Non'
          }
        ]}
        selectChoice={selectChoice}
      />
      <Button variant='yellow' onclick={() => swiper.slideNext()}>Valider</Button>
    </div>
  )
}

export default InfosStep;